/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useAuth } from "context/AuthProvider";
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media,
} from "reactstrap";

import { useNavigate } from "react-router-dom";
const AdminNavbar = (props) => {

  const {empresa, logOut} = useAuth();

  const navigate = useNavigate();
  const handleDatosEmpresa = (e) => {
    e.preventDefault();
    navigate("/admin/empresa")
  }

  const handleLogout = (e) =>{
    e.preventDefault()
    logOut();
  }

  const handleChangePassword = (e) => {
    e.preventDefault();
  
   navigate("/admin/configuracion");

  }

  const handleDescripciones =(e) =>{
    e.preventDefault();
    navigate("/admin/motivosAusencia")
  }

  const handleEnvioInformes =(e) =>{
    e.preventDefault();
    navigate("/admin/envioInformes")
  }

  const handleAsistente =(e) =>{
    e.preventDefault();
    navigate("/admin/asistente")
  }
  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <div
            className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
            //Separa el espacio para que el dropdown quede alineado
          >
          </div>
          
          <Nav className="align-items-center d-none d-md-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                  <img
                    alt="..."
                    src={require("../../assets/img/brand/favicon.png")}
                  />
                  </span>
                  <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold">
                      {empresa.nombre}
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">¡Bienvenido!</h6>
                </DropdownItem>
               <DropdownItem  onClick={(e) => handleDatosEmpresa(e)}>
                  <i className="ni ni-badge" />
                  <span>Datos empresa</span>
                </DropdownItem>
                 <DropdownItem  onClick={(e) => handleChangePassword(e)}>
                  <i className="ni ni-lock-circle-open" />
                  <span>Contraseña</span>
                </DropdownItem>               
                <DropdownItem  onClick={(e) => handleDescripciones(e)}>
                  <i className="ni ni-collection"/>
                  <span>Motivos ausencia</span>
                </DropdownItem>
                <DropdownItem  onClick={(e) => handleEnvioInformes(e)}>
                  <i className="ni ni-email-83" />
                  <span>Envio informes</span>
                </DropdownItem>
     
                <DropdownItem  onClick={(e) => handleAsistente(e)}>
                  <i className="ni ni-hat-3" />
                  <span>Asistente</span>
                </DropdownItem>
                <DropdownItem  onClick={(e) => handleLogout(e)}>
                  <i className="ni ni-user-run" />
                  <span>Cerrar sesión</span>
                </DropdownItem>
               
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;

